import { render, staticRenderFns } from "./ProvideFeedback.vue?vue&type=template&id=491d7962&"
import script from "./ProvideFeedback.vue?vue&type=script&lang=ts&"
export * from "./ProvideFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports